import { GrowthBook } from '@growthbook/growthbook-react';
import { LocalStorageStickyBucketService } from '@growthbook/growthbook';

export const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: import.meta.env.VITE_GROWTHBOOK_KEY,
  enableDevMode: import.meta.env.VITE_TEMP_MEE_ENV === 'development',
  subscribeToChanges: true,
  trackingCallback: (experiment, result) => {
    console.log('Experiment Viewed', {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
  stickyBucketService: new LocalStorageStickyBucketService(),
});

// Expose growthbook to window for debugging in development
if (
  import.meta.env.DEV ||
  import.meta.env.VITE_TEMP_MEE_ENV === 'development'
) {
  window._growthbook = growthbook;

  // Helper function to clear GrowthBook cache and refresh features
  window.clearGrowthBookCache = async () => {
    // Clear localStorage items related to GrowthBook
    const keys = Object.keys(localStorage);
    keys.forEach((key) => {
      if (key.includes('growthbook') || key.includes('gb_')) {
        localStorage.removeItem(key);
      }
    });

    // Refresh features from the server
    await growthbook.refreshFeatures();

    // Reload the page to apply changes
    window.location.reload();
  };
}

export const showCandidateOvertime = () => growthbook.isOn('should-use-overtime');
export const getShouldShowFrontDeskSpecialty = () =>
  growthbook.isOn('should-show-frontdesk-specialty');
export const getShouldOfficeShowEfda = () => growthbook.isOn('should-office-show-efda');
export const getShouldAllowOfficeToPostProcedure = () =>
  growthbook.isOn('should-allow-office-to-post-procedure');
export const getShouldUsingCredentialServiceEndpoint = () =>
  growthbook.isOn('should-use-credential-service-endpoint');
export const getShouldFilterRenouncedProcedures = () =>
  growthbook.isOn('should-filter-renounced-procedures');
export const enableChatsUnread = () => growthbook.isOn('enable-chats-unread');

export const enableLastJobPostedReminders = () =>
  growthbook.isOn('enable-last-job-posted-reminders');
export const enablePaymentExpirationReminders = () =>
  growthbook.isOn('enable-payment-expiration-reminders');
export const enableProfileCompletenessReminders = () =>
  growthbook.isOn('enable-profile-completeness-reminders');
export const getHideNotificationsOnParentOffice = () =>
  growthbook.isOn('hide-notifications-on-parent-office');

export const shouldUseDsoStructure = () => growthbook.isOn('use-office-service');

export const getShouldEnableReferralProgramV2 = () =>
  growthbook.isOn('TEMP-10881-enable-referral-program-v2');

export const getShouldDisableEmployeeReferralStates = () =>
  growthbook.getFeatureValue('TEMP-12342-employee-referral-disabled-states', '')?.split(',') || [];

export const getShouldAllowOfficeToPostProcedureBasedOnProfession = () =>
  growthbook.isOn('TEMP-11985-should-allow-office-to-post-procedure-based-on-profession');

/**
 * return as string
 * e.g : +18558794688
 */
export const getShouldUseCSPhone = () => growthbook.getFeatureValue('TEMP-13494-CS-phone');

export const getShouldUseModernComponent = () =>
  growthbook.getFeatureValue('TEMP-13565-use-modern-component', {});

export const getShouldUseSidebarRequestProfessionalMenu = () =>
  growthbook.getFeatureValue('TEMP-13847-sidebar-request-professional-menu', '')?.split(',') || [];

export const getShouldUseAttestaion = () =>
  growthbook.isOn('TEMP-13710-should-use-attestiontion-fe');

export const getShouldEnforcePermanentJobV2 = () =>
  growthbook.isOn('ARF-626-enforce-permanent-job-v2-dental-portal');

export const getShouldShowBackgroundCheckBadge = () =>
  growthbook.isOn('TEMP-14730-show-background-check-badge');

export const getShouldShowRatingInviteToEligibleJobsScreen = () =>
  growthbook.isOn(
    'TEMP-15938-dental-prompt-the-office-to-invite-a-professional-to-more-shifts-if-they-rated-them-highly',
  );

export * from './growthbookValue';
